
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { getAllOperList } from "@/api/api-basic";
import { State } from "vuex-class";
import { objAny } from "@/common/common-interface";
@Component
export default class SelectOper extends Vue {
  @Prop({ default: "" }) private width!: number | string;
  @Prop({ default: "" }) private pkid!: number | string;
  @Prop({ default: true }) private search!: boolean;
  @Watch("oprPkId")
  getVisible() {
    this.oprId = this.oprPkId;
  }
  @Model("value", { type: String }) private oprPkId!: string;
  @State("sys") sys!: objAny;
  private oprList: object[] = [];

  private oprId = "";
  async getStation(): Promise<void> {
    const ret = await getAllOperList({});
    if (ret.status === this.$config.apiStatus) {
      this.oprList = ret.data;
      this.$emit("success", this.oprList);
    }
  }

  public selectOper(val: string): void {
    val = val == undefined ? "" : val;
    this.oprId = val;
    this.$emit("value", val);
    this.$emit("on-change", val);
  }

  mounted() {
    if (this.search && this.sys.userType !== "admin") {
      this.oprId = this.sys.operInfo.oprPkId;
      this.$emit("value", this.oprId);
      this.oprList = [
        {
          oprPkId: this.sys.operInfo.oprPkId,
          oprName: this.sys.operInfo.oprName
        }
      ];
    } else {
      this.oprId = this.oprPkId;
      this.getStation();
    }
  }
}
